import { createApp } from 'vue'
import { CHECK, LOGIN, LOGOUT, BOOT_HASH, HASH_ID, FRESH, REFRESH_TOKEN_LIFETIME } from "./mutation-types";
// import { EventBus } from "Resources/event-bus.js";
import Hashids from 'hashids';
import Hasher from 'Resources/encrypt/Hasher';

/* eslint-disable no-param-reassign */
export default {
    [BOOT_HASH](state) {
        const hashids = new Hashids('fc01dce63eb541fcb204ce96c9250ba0', 15);
        state.hashids = hashids;
    },
    [HASH_ID](state, id) {
        return id;
    },
    [CHECK](state) {
        state.authenticated = Hasher.getItem("auth");
        if (state.authenticated) {
            state.type = "account";
            createApp.$http.defaults.headers.common.Authorization = `Bearer ${Hasher.getItem(
                "accessToken"
            )}`;
        }
    },
    [REFRESH_TOKEN_LIFETIME](state){

        let now = new Date();

        now.setHours(now.getHours() + state.ttl);

        Hasher.setItem("token_lifetime", now.getTime(), false);

        // console.warn('Token Refreshed ...');
    },
    [LOGIN](state, response) {
        state.authenticated = true;
        state.token = response.token;
        state.user = response.user;

        Hasher.setItem("auth", !!state.authenticated);
        Hasher.setItem("accessToken", state.token);
        Hasher.setItem("user", state.user);
        // EventBus.$emit("localeChange", state.user.locale);
        console.log("login success");
    },

    [FRESH](state, user) {
        state.user = user;

        Hasher.setItem("user", state.user);
    },

    [LOGOUT](state) {
        state.authenticated = false;
        state.token = "";
        state.user = {};
        Hasher.removeItem("auth");
        Hasher.removeItem("accessToken");
        Hasher.removeItem("user");
        Hasher.removeItem("locale");
    },
};